export const FileUploadConstants = {
  MAX_SIZE_MB: 10,
  MAX_SIZE_BYTES: 10 * 1024 * 1024,
  ALLOWED_MIME_TYPE: 'text/csv',
  ALLOWED_EXTENSION: '.csv',
} as const;
